// extracted by mini-css-extract-plugin
export default {"contactBlock":"ContactBlock_contactBlock__VSi18","contactName":"ContactBlock_contactName__xK8on","messageButton":"ContactBlock_messageButton__dfKaD"};